<template>
  <div class="shopping-cart-modular">
    <!-- <van-swipe-cell>
      <template #left>
        <van-button square type="primary" text="选择" />
      </template>
      <van-cell :border="false" title="单元格" value="内容" />
      <template #right>
        <van-button square type="danger" text="删除" />
        <van-button square type="primary" text="收藏" />
      </template>
    </van-swipe-cell> -->
    <!-- <div style="margin: 20px auto;width: 1200px;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{currLanguage==3?"Home":pageTextArr[0]}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{currLanguage==3?"Shopping cart":pageTextArr[1]}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div> -->
    <div class="header-menu-bar-modular" style="background-color: transparent">
      <div class="menu-bar">
        <div class="menu-bar-item">
          <span class="top-bar-title" @click="toPersonCenter()">{{
            currLanguage == 3 ? "Home" : pageTextArr[0]
          }}</span>
          <img
            class="top-bar-icon"
            src="../assets/productDetail/top-bar-icon.png"
            alt=""
          />
        </div>
        <div class="menu-bar-item">
          <span class="top-bar-title">{{ pageTextArr[1] }}</span>
        </div>
      </div>
    </div>
    <div class="shopping-cart-body-modular">
      <div class="header">
        <div class="header-left-title">
          {{ pageTextArr[1] }}({{ pageCount }})
        </div>
        <div class="header-right">
          <span class="select-rule-title"
            >{{ pageTextArr[2] }}{{ pageTextArr[3] }}</span
          >
          <span class="select-product-price">{{
            currencySymbol + selectProductPricrSum
          }}</span>
          <el-button class="settlement-btn" @click="settlement()">{{
            pageTextArr[4]
          }}</el-button>
        </div>
      </div>
      <div class="body">
        <div class="shopping-cart-thead">
          <div class="thead-item thead-item1" @click="allCheckbox()">
            <img
              class="checkbox-icon"
              v-if="!isAllCheckbox"
              src="../assets/shopping-cart/checkbox-icon-0.png"
              alt=""
            />
            <img
              class="checkbox-icon"
              v-else
              src="../assets/shopping-cart/checkbox-icon-1.png"
              alt=""
            />
            <span class="all-checkbox">{{ pageTextArr[5] }}</span>
          </div>
          <div class="thead-item thead-item2"></div>
          <div class="thead-item thead-item3">
            {{ pageTextArr[6] }}
          </div>
          <div class="thead-item thead-item4">
            {{ pageTextArr[7] }}
          </div>
          <div class="thead-item thead-item5">
            {{ pageTextArr[8] }}
          </div>
          <div class="thead-item thead-item6">
            {{ pageTextArr[9] }}
          </div>
          <div class="thead-item thead-item7">
            {{ pageTextArr[10] }}
          </div>
        </div>
        <div class="shopping-cart-tbody" v-loading="cartLoading">
          <!-- {{ shoppCartProductList.length }} -->
          <div
            v-if="shoppCartProductList.length == 0"
            class="my-evaluate-bodu-none-center"
          >
            <img
              class="none-icon"
              src="../assets/public/none-icon.png"
              alt=""
            />
            <p class="none-title">{{ pageTextArr[19] }}</p>
          </div>
          <div
            v-else
            v-for="(item, index) in shoppCartProductList"
            :key="index"
            class="combination-product-list"
          >
            <!-- 组合商品 pc-->
            <div v-if="item.type == 2">
              <div
                class="hopping-cart-product-combination-item pc"
                v-for="(item3, index3) in item.product_data"
                :key="index3"
              >
                <div class="tbody-item tbody-item1">
                  <div v-if="index3 == 0">
                    <img
                      class="checkbox-icon"
                      v-if="item.flag"
                      src="../assets/shopping-cart/checkbox-icon-1.png"
                      alt=""
                      @click="changePriceByChecked(index)"
                    />
                    <img
                      class="checkbox-icon"
                      v-else
                      src="../assets/shopping-cart/checkbox-icon-0.png"
                      alt=""
                      @click="changePriceByChecked(index)"
                    />
                  </div>
                </div>
                <div class="tbody-item tbody-item2">
                  <div class="show-img-item">
                    <img class="show-img" :src="item3.cover" alt="" />
                  </div>
                </div>
                <div class="tbody-item tbody-item3">
                  <div class="tbody-item-info-voltage">
                    <div class="produce-info">
                      {{ currLanguage == 3 ? item3.eng_title : item3.title }}
                    </div>
                    <div class="product-voltage">
                      {{
                        currLanguage == 3
                          ? item3.eng_specifications
                          : item3.specifications
                      }}
                    </div>
                  </div>
                </div>
                <div class="tbody-item tbody-item4">
                  <div v-if="index3 == 0">
                    <div class="originalPrice">
                      {{ currencySymbol + item.total_price }}
                    </div>
                    <div class="presentPrice">
                      {{ currencySymbol + item.total_discount_price }}
                    </div>
                  </div>
                </div>
                <div class="tbody-item tbody-item5">
                  <div v-if="index3 == 0">
                    <van-stepper
                      v-model="item3.num"
                      integer
                      input-width="40px"
                      button-size="32px"
                      @plus="setCartNum(item.id, parseFloat(item3.num) + 1)"
                      @minus="setCartNum(item.id, parseFloat(item3.num) - 1)"
                      @blur="setCartNum1(item.id, parseFloat(item3.num))"
                    />
                    <!-- <inputNumber ref="inputContainerRef" :number="parseFloat(item3.num)" :index="index"></inputNumber> -->
                  </div>
                </div>
                <div class="tbody-item tbody-item6">
                  <div v-if="index3 == 0">
                    <div class="amountMoney">
                      {{ currencySymbol + item.amountMoney }}
                    </div>
                  </div>
                </div>
                <div class="tbody-item tbody-item7">
                  <div v-if="index3 == 0">
                    <!-- <div
                    class="add-favorites"
                    @click="
                      productaddCollect(item3.id, item3.is_collect, index, 1)
                    "
                    v-if="item3.is_collect == 0"
                  >
                    {{ $t("translateText.addtofavoritesText") }}
                  </div>
                  <div
                    class="add-favorites"
                    @click="
                      productaddCollect(item3.id, item3.is_collect, index, 1)
                    "
                    v-else
                  >
                    {{ $t("translateText.havecollectedText") }}
                  </div> -->
                    <!-- <div class="delete" @click="setCartNum(item.id, 0)">{{ (currLanguage == 3 ? 'Delete' : '删除') }}</div> -->
                    <el-popconfirm
                      :confirm-button-text="pageTextArr[20]"
                      :cancel-button-text="pageTextArr[21]"
                      icon="el-icon-info"
                      icon-color="red"
                      :title="pageTextArr[22]"
                      @confirm="setCartNum(item.id, 0)"
                    >
                      <div class="delete delete1" slot="reference">
                        {{ pageTextArr[23] }}
                      </div>
                    </el-popconfirm>
                  </div>
                </div>
              </div>
            </div>
            <!-- 组合商品 iphone-->
            <van-swipe-cell
              v-for="(item3, index3) in item.product_data"
              :key="index3"
            >
              <div
                class="hopping-cart-product-combination-item iphone"
                v-if="item.type == 2"
              >
                <div class="tbody-item tbody-item1">
                  <div v-if="index3 == 0">
                    <img
                      class="checkbox-icon"
                      v-if="item.flag"
                      src="../assets/shopping-cart/checkbox-icon-1.png"
                      alt=""
                      @click="changePriceByChecked(index)"
                    />
                    <img
                      class="checkbox-icon"
                      v-else
                      src="../assets/shopping-cart/checkbox-icon-0.png"
                      alt=""
                      @click="changePriceByChecked(index)"
                    />
                  </div>
                </div>
                <div class="tbody-item tbody-item2">
                  <div class="show-img-item">
                    <img class="show-img" :src="item3.cover" alt="" />
                  </div>
                </div>
                <div class="tbody-item-right">
                  <div class="tbody-item tbody-item3">
                    <div class="tbody-item-info-voltage">
                      <div class="produce-info">
                        {{ currLanguage == 3 ? item3.eng_title : item3.title }}
                      </div>
                      <div class="product-voltage">
                        {{
                          currLanguage == 3
                            ? item3.eng_specifications
                            : item3.specifications
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="tbody-item456">
                    <div class="tbody-item tbody-item4">
                      <div v-if="index3 == 0">
                        <div class="originalPrice">
                          {{ currencySymbol + item.total_price }}
                        </div>
                        <div class="presentPrice">
                          {{ currencySymbol + item.total_discount_price }}
                        </div>
                      </div>
                    </div>
                    <div class="tbody-item tbody-item5">
                      <div v-if="index3 == 0">
                        <van-stepper
                          v-model="item3.num"
                          integer
                          input-width="40px"
                          button-size="32px"
                          @plus="setCartNum(item.id, parseFloat(item3.num) + 1)"
                          @minus="
                            setCartNum(item.id, parseFloat(item3.num) - 1)
                          "
                          @blur="setCartNum1(item.id, parseFloat(item3.num))"
                        />
                        <!-- <inputNumber ref="inputContainerRef" :number="parseFloat(item3.num)" :index="index"></inputNumber> -->
                      </div>
                    </div>
                    <div class="tbody-item tbody-item6">
                      <div v-if="index3 == 0">
                        <div class="amountMoney">
                          {{ currencySymbol + item.amountMoney }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="tbody-item tbody-item7">
                <div v-if="index3 == 0">
                  <div class="add-favorites">
                    {{ currLanguage == 3 ? "Add Favorites" : "加入收藏夹" }}
                  </div>
                  <div class="delete" @click="setCartNum(item.id, 0)">{{ (currLanguage == 3 ? 'Delete' : '删除') }}</div>
                  <el-popconfirm
                    :confirm-button-text="currLanguage == 3 ? 'YES?' : '确定'"
                    :cancel-button-text="currLanguage == 3 ? 'NO?' : '取消'"
                    icon="el-icon-info"
                    icon-color="red"
                    :title="
                      currLanguage == 3
                        ? 'Are you sure to delete the current item?'
                        : '确定删除当前商品？'
                    "
                    @confirm="setCartNum(item.id, 0)"
                  >
                    <div class="delete" slot="reference">
                      {{ currLanguage == 3 ? "Delete" : "删除" }}
                    </div>
                  </el-popconfirm>
                </div>
              </div> -->
              </div>
              <template #right>
                <van-button
                  square
                  :text="pageTextArr[23]"
                  type="danger"
                  class="delete-button"
                  @click="setCartNum(item.id, 0)"
                />
                <!-- <van-button
                  square
                  :text="$t('translateText.addtofavoritesText')"
                  type="warning"
                  class="delete-button"
                  @click="
                    productaddCollect(item3.id, item3.is_collect, index, 1)
                  "
                  v-if="item3.is_collect == 0"
                />
                <van-button
                  square
                  :text="$t('translateText.havecollectedText')"
                  type="warning"
                  class="delete-button"
                  @click="
                    productaddCollect(item3.id, item3.is_collect, index, 1)
                  "
                  v-else
                /> -->
              </template>
            </van-swipe-cell>
            <!-- 单个商品 pc-->
            <div v-if="item.type == 1">
              <div
                class="shopping-cart-product-item pc"
                v-for="(item2, index2) in item.product_data"
                :key="index2"
              >
                <div class="tbody-item tbody-item1">
                  <img
                    class="checkbox-icon"
                    v-if="item.flag"
                    src="../assets/shopping-cart/checkbox-icon-1.png"
                    alt=""
                    @click="changePriceByChecked(index)"
                  />
                  <img
                    class="checkbox-icon"
                    v-else
                    src="../assets/shopping-cart/checkbox-icon-0.png"
                    alt=""
                    @click="changePriceByChecked(index)"
                  />
                </div>
                <div class="tbody-item tbody-item2">
                  <div class="show-img-item">
                    <img class="show-img" :src="item2.cover" alt="" />
                  </div>
                </div>
                <div class="tbody-item tbody-item3">
                  <div class="tbody-item-info-voltage">
                    <div class="produce-info">
                      {{ currLanguage == 3 ? item2.eng_title : item2.title }}
                    </div>
                    <div class="product-voltage">
                      {{
                        currLanguage == 3
                          ? item2.eng_specifications
                          : item2.specifications
                      }}
                    </div>
                  </div>
                </div>
                <div class="tbody-item tbody-item4">
                  <!-- 有优惠 -->
                  <div class="originalPrice" v-if="item2.has_discount == 1">
                    {{ currencySymbol + parseFloat(item2.price) }}
                  </div>
                  <!-- 有优惠 -->
                  <div class="presentPrice" v-if="item2.has_discount == 1">
                    {{ currencySymbol + parseFloat(item2.discount_price) }}
                  </div>
                  <!-- 没有有优惠 -->
                  <div class="presentPrice" v-else>
                    {{ currencySymbol + parseFloat(item2.price) }}
                  </div>
                </div>
                <div class="tbody-item tbody-item5">
                  <van-stepper
                    v-model="item2.num"
                    integer
                    input-width="40px"
                    button-size="32px"
                    @plus="setCartNum(item.id, parseFloat(item2.num) + 1)"
                    @minus="setCartNum(item.id, parseFloat(item2.num) - 1)"
                    @blur="setCartNum1(item.id, parseFloat(item2.num))"
                  />
                  <!-- <inputNumber ref="inputContainerRef" :number="parseFloat(item2.num)" :index="index"></inputNumber> -->
                </div>
                <div class="tbody-item tbody-item6">
                  <div class="amountMoney">
                    {{ currencySymbol + item.amountMoney }}
                  </div>
                </div>

                <div class="tbody-item tbody-item7">
                  <div
                    class="add-favorites"
                    v-if="item2.is_collect == 0"
                    @click="
                      productaddCollect(item2.id, item2.is_collect, index, 1)
                    "
                  >
                    {{ pageTextArr[11] }}
                  </div>
                  <div
                    class="add-favorites"
                    @click="
                      productaddCollect(item2.id, item2.is_collect, index, 1)
                    "
                    v-else
                  >
                    {{ pageTextArr[24] }}
                  </div>
                  <el-popconfirm
                    :confirm-button-text="pageTextArr[20]"
                    :cancel-button-text="pageTextArr[21]"
                    icon="el-icon-info"
                    icon-color="red"
                    :title="pageTextArr[22]"
                    @confirm="setCartNum(item.id, 0)"
                  >
                    <div class="delete" slot="reference">
                      {{ pageTextArr[23] }}
                    </div>
                  </el-popconfirm>
                  <!-- <div class="delete" @click="setCartNum(item.id, 0)">{{ (currLanguage == 3 ? 'Delete' : '删除') }}</div> -->
                </div>
              </div>
            </div>

            <!-- 单个商品 iphone-->
            <!-- <van-swipe-cell>
              <div
                class="shopping-cart-product-item iphone"
                v-for="(item2, index2) in item.product_data"
                :key="index2"
              >
                <div>{{ item2.title }}</div>
              </div>
              <template #right>
                <van-button square type="danger" text="删除" />
                <van-button square type="primary" text="收藏" />
              </template>
            </van-swipe-cell> -->

            <van-swipe-cell
              v-for="(item2, index2) in item.product_data"
              :key="index2"
            >
              <div
                class="shopping-cart-product-item iphone"
                v-if="item.type == 1"
              >
                <div class="tbody-item tbody-item1">
                  <img
                    class="checkbox-icon"
                    v-if="item.flag"
                    src="../assets/shopping-cart/checkbox-icon-1.png"
                    alt=""
                    @click="changePriceByChecked(index)"
                  />
                  <img
                    class="checkbox-icon"
                    v-else
                    src="../assets/shopping-cart/checkbox-icon-0.png"
                    alt=""
                    @click="changePriceByChecked(index)"
                  />
                </div>
                <div class="tbody-item tbody-item2">
                  <div class="show-img-item">
                    <img class="show-img" :src="item2.cover" alt="" />
                  </div>
                </div>
                <div class="tbody-item-right">
                  <div class="tbody-item tbody-item3">
                    <div class="tbody-item-info-voltage">
                      <div class="produce-info">
                        {{ currLanguage == 3 ? item2.eng_title : item2.title }}
                      </div>
                      <div class="product-voltage">
                        {{
                          currLanguage == 3
                            ? item2.eng_specifications
                            : item2.specifications
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="tbody-item456">
                    <div class="tbody-item tbody-item4">
                      <!-- 有优惠 -->
                      <div class="originalPrice" v-if="item2.has_discount == 1">
                        {{ currencySymbol + parseFloat(item2.price) }}
                      </div>
                      <!-- 有优惠 -->
                      <div class="presentPrice" v-if="item2.has_discount == 1">
                        {{ currencySymbol + parseFloat(item2.discount_price) }}
                      </div>
                      <!-- 没有有优惠 -->
                      <div class="presentPrice" v-else>
                        {{ currencySymbol + parseFloat(item2.price) }}
                      </div>
                    </div>
                    <div class="tbody-item tbody-item5">
                      <van-stepper
                        v-model="item2.num"
                        integer
                        input-width="40px"
                        button-size="32px"
                        @plus="setCartNum(item.id, parseFloat(item2.num) + 1)"
                        @minus="setCartNum(item.id, parseFloat(item2.num) - 1)"
                        @blur="setCartNum1(item.id, parseFloat(item2.num))"
                      />
                      <!-- <inputNumber ref="inputContainerRef" :number="parseFloat(item2.num)" :index="index"></inputNumber> -->
                    </div>
                    <div class="tbody-item tbody-item6">
                      <div class="amountMoney">
                        {{ currencySymbol + item.amountMoney }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <template #right>
                <van-button
                  square
                  :text="pageTextArr[23]"
                  type="danger"
                  class="delete-button"
                  @click="setCartNum(item.id, 0)"
                />
                <van-button
                  square
                  :text="pageTextArr[11]"
                  type="warning"
                  class="delete-button"
                  @click="
                    productaddCollect(item2.id, item2.is_collect, index, 1)
                  "
                  v-if="item2.is_collect == 0"
                />
                <van-button
                  square
                  :text="pageTextArr[24]"
                  type="warning"
                  class="delete-button"
                  @click="
                    productaddCollect(item2.id, item2.is_collect, index, 1)
                  "
                  v-else
                />
              </template>
            </van-swipe-cell>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-left-title">
          <span>{{ pageTextArr[1] }}({{ pageCount }})</span>
          <el-popconfirm
            :confirm-button-text="pageTextArr[20]"
            :cancel-button-text="pageTextArr[21]"
            icon="el-icon-info"
            icon-color="red"
            :title="pageTextArr[25]"
            @confirm="clearCart()"
          >
            <div class="clear-btn" slot="reference">
              {{ pageTextArr[25] }}
            </div>
          </el-popconfirm>
          <!-- <el-button class="clear-btn" @click="clearCart()">清空购物车</el-button> -->
        </div>
        <div class="footer-right">
          <div>
            <span class="select-rule-title"
              >{{ pageTextArr[13]
              }}<span class="footer-num">{{ pageCount }}</span
              >{{ pageTextArr[14] }}({{ pageTextArr[15] }})</span
            >
            <span class="select-product-price">{{
              currencySymbol + selectProductPricrSum
            }}</span>
          </div>
          <el-button class="settlement-btn" @click="settlement()">{{
            pageTextArr[4]
          }}</el-button>
        </div>
      </div>
      <!-- <div class="pagination-footer-modualr">
        <el-pagination
          :pager-count="11"
          background
          layout="prev, pager, next"
          :total="pageCount"
          @current-change="handleCurrentChange()"
        >
        </el-pagination>
      </div> -->
      <div class="recommend-product-modular">
        <div class="commodity-recommend-modular">
          <div class="recommend-title-modular">
            <img
              class="recommend-img"
              src="../assets/home/recommend-title-left-icon.png"
              alt=""
            />
            <span class="recommend-text">{{
              currLanguage == 3
                ? recommendProductText.eng_name
                : recommendProductText.name
            }}</span>
            <img
              class="recommend-img"
              src="../assets/home/recommend-title-right-icon.png"
              alt=""
            />
          </div>
          <div class="commodity-show-modular">
            <div
              v-if="recommendProductData.length == 0"
              class="my-evaluate-bodu-none-center"
            >
              <img
                class="none-icon"
                src="../assets/public/none-icon.png"
                alt=""
              />
              <p class="none-title">{{ pageTextArr[19] }}</p>
            </div>
            <div
              v-else
              class="commodity-show-item-modualr"
              v-for="(item, index) in recommendProductData"
              :key="index"
            >
              <div class="commodity-show-item" v-if="index < 5">
                <div
                  class="commodity-show-item-img"
                  @click="toProductDetail(item.id)"
                >
                  <img class="commodity-show-img" :src="item.cover" alt="" />
                </div>
                <div class="commodity-show-item-msg">
                  <div class="commodity-show-item-price">
                    {{ currencySymbol
                    }}{{
                      item.has_discount == 1 ? item.discount_price : item.price
                    }}
                    <span
                      class="commodity-show-item-discpunt-price"
                      v-if="item.has_discount == 1"
                    >
                      {{ currencySymbol }}{{ item.price }}
                    </span>
                  </div>
                  <div class="commodity-show-item-introduce">
                    {{ currLanguage == 3 ? item.eng_title : item.title }}
                  </div>
                  <div class="commodity-show-item-evaluate">
                    <div class="commodity-evaluate">
                      <!-- <span class="commodity-evaluate-num">{{
                        item.comment_num
                      }}</span>
                      <span class="commodity-evaluate-title">{{
                        $t("translateText.appraiseText")
                      }}</span> -->
                    </div>
                    <div class="commodity-coupon" v-if="item.has_coupon == 1">
                      {{ pageTextArr[16] }}
                    </div>
                  </div>
                  <div class="commodity-show-item-operation">
                    <div
                      class="commodity-shop-cart"
                      @click="toProductDetail(item.id)"
                    >
                      <span class="add-cart-title">{{ pageTextArr[17] }}</span>
                    </div>
                  </div>
                  <div class="commodity-show-item-operation">
                    <!-- <div
                      class="commodity-collection"
                      @click="
                        productaddCollect(item.id, item.is_collect, index, 2)
                      "
                    >
                      <img
                        class="collection-icon"
                        v-if="item.is_collect == 1"
                        src="../assets/home/collection-icon-2.png"
                        alt=""
                      />
                      <img
                        class="collection-icon"
                        v-else
                        src="../assets/home/collection-icon.png"
                        alt=""
                      />

                      <span class="collection-title">{{
                        $t("translateText.collectText")
                      }}</span>
                    </div> -->
                    <div
                      class="commodity-shop-cart shop-cart-color"
                      @click="
                        productAddCart(
                          item.id,
                          item.number,
                          1,
                          item.portfolio_sales_middle_id,
                          cartNum
                        )
                      "
                    >
                      <!-- <img
                        class="shop-cart-icon"
                        src="../assets/home/shop-cart-icon.png"
                        alt=""
                      /> -->
                      <span class="add-cart-title">{{ pageTextArr[18] }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="commodity-recommend-modular">
          <div class="recommend-title-modular">
            <img
              class="recommend-img"
              src="../assets/home/recommend-title-left-icon.png"
              alt=""
            />
            <span class="recommend-text">{{
              currLanguage == 3 ? "hot-sale product" : "热销产品"
            }}</span>
            <img
              class="recommend-img"
              src="../assets/home/recommend-title-right-icon.png"
              alt=""
            />
          </div>
          <div class="commodity-show-modular commodity-ho-sale">
            <div
              v-if="hotSaleProductData.length == 0"
              class="my-evaluate-bodu-none-center"
            >
              <img
                class="none-icon"
                src="../assets/public/none-icon.png"
                alt=""
              />
              <p class="none-title">暂无数据~</p>
            </div>
            <div
              v-else
              class="commodity-show-item-modualr"
              v-for="(item, index) in hotSaleProductData"
              :key="index"
            >
              <div class="commodity-show-item" v-if="index < 5">
                <div
                  class="commodity-show-item-img"
                  @click="toProductDetail(item.id)"
                >
                  <img class="commodity-show-img" :src="item.cover" alt="" />
                </div>
                <div class="commodity-show-item-msg">
                  <div class="commodity-show-item-price">
                    {{ currencySymbol
                    }}{{ item.has_discount ? item.discount_price : item.price }}
                    <span
                      class="commodity-show-item-discpunt-price"
                      v-if="item.has_discount == 1"
                    >
                      {{ currencySymbol }}{{ item.price }}
                    </span>
                  </div>
                  <div class="commodity-show-item-introduce">
                    {{ currLanguage == 3 ? item.eng_title : item.title }}
                  </div>
                  <div class="commodity-show-item-evaluate">
                    <div class="commodity-evaluate">
                      <span class="commodity-evaluate-num">{{
                        item.comment_num
                      }}</span>
                      <span class="commodity-evaluate-title">{{
                        currLanguage == 3 ? "Evaluate" : "评价"
                      }}</span>
                    </div>
                    <div class="commodity-coupon" v-if="item.has_coupon == 1">
                      {{ currLanguage == 3 ? "Coupon" : "券" }}
                    </div>
                  </div>
                  <div class="commodity-show-item-operation">
                    <div class="commodity-collection">
                      <img
                        class="collection-icon"
                        src="../assets/home/collection-icon.png"
                        alt=""
                      />
                      <span class="collection-title">{{
                        currLanguage == 3 ? "Collection" : "收藏"
                      }}</span>
                    </div>
                    <div class="commodity-shop-cart">
                      <img
                        class="shop-cart-icon"
                        src="../assets/home/shop-cart-icon.png"
                        alt=""
                      />
                      <span
                        class="add-cart-title"
                        @click="
                          productAddCart(
                            item.id,
                            item.number,
                            1,
                            item.portfolio_sales_middle_id,
                            1
                          )
                        "
                        >{{
                          currLanguage == 3 ? "addCart" : "加入购物车"
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import inputNumber from "../components/public/InputNumber";

export default {
  components: {
    inputNumber,
  },
  data() {
    return {
      cartLoading: false, //loding
      page: 1,
      pagesize: 10,
      pageCount: 0,
      isAllCheckbox: false, //是否全选
      // shopCartNum: 0,//商品数量
      selectProductPricrSum: 0, //总价
      recommendProductText: {},
      recommendProductData: [], //1为你推荐
      hotSaleProductData: [], //2热销产品
      guessLikeProductData: [], //3猜你喜欢
      currLanguage: 1, //当前语言
      shoppCartProductList: [], //购物车
      currencySymbol: localStorage.getItem("currencySymbol"),
      collectionFlag: 0, //1-已收藏，0-没有
      pageTextArr: [
        "首页",
        "购物车",
        "已选产品",
        "不含运费",
        "结算",
        "全选",
        "产品信息",
        "单价",
        "数量",
        "金额",
        "操作",
        "加入收藏夹",
        "清空购物车",
        "合计",
        "商品数",
        "为你推荐",
        "优惠券",
        "产品细节",
        "加入购物车",
        "暂无数据",
        "确认",
        "取消",
        "确定删除当前商品？",
        "删除",
        "已收藏",
        "确认清空购物车",
      ],
    };
  },
  methods: {
    /**
     * 全选
     */
    allCheckbox() {
      let that = this;
      that.isAllCheckbox = !that.isAllCheckbox;
      that.shoppCartProductList.forEach((v, i) => {
        v.flag = that.isAllCheckbox;
      });
      // 计算购物车价格
      that.calculationTotalPrice();
    },

    /**
     * 结算获取选中的数据
     */
    getProducListBychecked() {
      let that = this;

      let product_list = []; //选中商品数据
      that.shoppCartProductList.forEach((v, i) => {
        if (v.flag) {
          product_list.push({
            product_id: v.product_data[0].id,
            sku_number: v.product_data[0].number,
            type: v.type,
            num: v.product_data[0].num,
            typeid: v.product_data[0].typeid,
            has_discount: v.product_data[0].has_discount,
            has_wholesale_price: v.product_data[0].has_wholesale_price,
            wholesale_price_id: v.product_data[0].wholesale_price_id,
            cart_id: v.id,
            portfolio_sales_middle_id: v.portfolio_sales_middle_id,
            price: v.product_data[0].price,
            discount_price: v.product_data[0].discount_price,
            time_discount_id: v.product_data[0].time_discount_id,
          });
        }
      });
      return product_list;
    },

    /**
     * 结算
     */
    settlement() {
      let that = this;
      // 清除
      localStorage.removeItem("localStorageProductData");
      let data = {
        price: that.selectProductPricrSum,
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
        exchange_rate_symbol: localStorage.getItem("currencySymbol"),
      };
      let productData = that.getProducListBychecked();
      if (productData.length == 0) {
        this.$message.warning(
          this.currLanguage == 3
            ? "Please select the product to purchase"
            : "请选择要购买的商品"
        );
        return;
      } else {
        productData = that.getProducListBychecked();
      }
      let localStorageProductData = {
        productData: productData,
        productPrice: that.selectProductPricrSum,
      };
      localStorage.setItem(
        "localStorageProductData",
        JSON.stringify(localStorageProductData)
      );

      if (this.$parent.tipsLogin()) return;
      this.$router.push({
        path: "/confirmOrder",
      });
    },

    /**
     * 分页-page发送变化
     * @param {*} val
     */
    handleCurrentChange(val) {
      let that = this;
      that.page = val;
      that.getCartList();
    },

    /**
     * 跳转商品详情
     * @param {*} id
     */
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { product_id: id },
      });
    },

    /**
     * 商品加入购物车
     * @param {*} product_id
     * @param {*} sku_number
     * @param {*} type
     * @param {*} portfolio_sales_middle_id
     * @param {*} cartNum
     */
    productAddCart(
      product_id,
      sku_number,
      type,
      portfolio_sales_middle_id,
      cartNum
    ) {
      let that = this;
      let statusFlag = that.$parent.addCart(
        product_id,
        sku_number,
        type,
        portfolio_sales_middle_id,
        cartNum
      );
      if (statusFlag) {
        that.cartLoading = true;
        setTimeout(() => {
          that.getCartList();
        }, 200);
      }
      // that.$parent.addCart(product_id, sku_number, type, portfolio_sales_middle_id, cartNum);
    },

    /**
     * 购物车列表
     */
    getCartList() {
      let that = this;

      let data = {
        page: that.page,
        pagesize: that.pagesize,
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
        exchange_rate_symbol: localStorage.getItem("currencySymbol"),
        cookie: that.getCookies(),
      };
      this.$http.getCartList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.cartLoading = false;
            // list
            that.shoppCartProductList = res.data;
            that.pageCount = parseFloat(res.total);

            if (
              that.shoppCartProductList.length > 0 &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.translateApiData(that.shoppCartProductList, "1", "product");
            }
            // 添加属性
            that.addCheckedStatus();
            // 计算价格
            that.calculationTotalPrice();
            // 是否全选
            // this.isAllCheckbox = true
            // that.isAllCheckboxFlag();
            if (that.isAllCheckbox == true) {
              // console.log("that.isAllCheckbox");
              that.isAllCheckbox = false;
              that.allCheckbox();
            }
          } else {
            that.cartLoading = false;
            // console.log("that.pageCount",that.pageCount);
            that.shoppCartProductList = [];
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          if (res.ret == 0) {
            that.pageCount = 0;
            console.log("that.pageCount", that.pageCount);
          }
          that.shoppCartProductList = [];
          that.cartLoading = false;
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 是否全选
     */
    isAllCheckboxFlag() {
      let that = this;
      let checkegArr = [];
      that.shoppCartProductList.forEach((v, i) => {
        if (v.flag) {
          checkegArr.push(i);
        }
      });
      if (checkegArr.length == that.shoppCartProductList.length) {
        that.isAllCheckbox = true;
      } else {
        that.isAllCheckbox = false;
      }
    },

    /**
     * 添加选中属性
     */
    addCheckedStatus() {
      let that = this;
      that.shoppCartProductList.forEach((v, i) => {
        v.flag = false;
      });
    },

    /**
     * 单个复选框改变-更改价格
     * @param {*} parentIndex
     */
    changePriceByChecked(parentIndex) {
      let that = this;
      let newData = [];
      newData = that.shoppCartProductList[parentIndex];
      newData.flag = !newData.flag;
      that.$set(that.shoppCartProductList, parentIndex, newData);
      // 计算购物车价格
      that.calculationTotalPrice();
    },

    /**
     * 计算购物车价格
     */
    calculationTotalPrice() {
      let that = this;
      that.selectProductPricrSum = 0; // 清空
      that.shoppCartProductList.forEach((v, i) => {
        // 单个
        if (v.type == 1) {
          // 金额
          if (v.product_data[0].has_discount == 0) {
            // 没有优惠
            v.amountMoney =
              parseFloat(v.product_data[0].price) *
              parseFloat(v.product_data[0].num);
            // 结算金额-只有选中的情况下
            if (v.flag) {
              that.selectProductPricrSum +=
                parseFloat(v.product_data[0].price) *
                parseFloat(v.product_data[0].num);
            }
          } else {
            // 有优惠
            v.amountMoney =
              parseFloat(v.product_data[0].discount_price) *
              parseFloat(v.product_data[0].num);
            if (v.flag) {
              // 结算金额
              that.selectProductPricrSum +=
                parseFloat(v.product_data[0].discount_price) *
                parseFloat(v.product_data[0].num);
            }
          }
          // if (v.flag) {
          v.amountMoney = Math.ceil(v.amountMoney * 100) / 100;
          // }
        } else {
          // 组合
          if (v.flag) {
            that.selectProductPricrSum +=
              parseFloat(v.total_discount_price) *
              parseFloat(v.product_data[0].num);
          }
          // 金额
          v.amountMoney =
            parseFloat(v.total_discount_price) *
            parseFloat(v.product_data[0].num);
          v.amountMoney = Math.ceil(v.amountMoney * 100) / 100;
        }
      });
      // 向上取证保留两位小数
      that.selectProductPricrSum =
        Math.ceil(that.selectProductPricrSum * 100) / 100;
    },

    /**
     * 商品列表
     * @param {*} id
     */
    getProductSignList(id) {
      let that = this;
      let data = {
        id: id,
        type_id: 0,
        page: 1,
        pagesize: 5,
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
      };
      this.$http.getProductSignList(
        data,
        (res) => {
          if (res.ret == 1) {
            //  商品数据赋值
            that.setProductById(id, res);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 更改数量
     */
    setProductNum(index, number) {
      let that = this;
      that.shoppCartProductList[index].product_data[0].num = number;
      that.setCartNum(that.shoppCartProductList[index].id, number);
    },
    /**
     * 更改购物车数量
     * @param {*} id
     * @param {*} number
     */
    setCartNum1(id, number) {
      let that = this;
      console.log("number", number);
      if (!number) {
        number = 1;
        console.log("number", number);
      }
      let data = {
        cart_id: id,
        num: number,
      };
      // console.log('number-------',number);
      // return
      that.cartLoading = true;
      this.$http.setCartNum(
        data,
        (res) => {
          if (res.ret == 1) {
            that.getCartList();
            that.$parent.getCartNum(); //调用父组件获取购物车的数量的方法
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 更改购物车数量
     * @param {*} id
     * @param {*} number
     */
    setCartNum(id, number) {
      let that = this;
      console.log("number", number);
      // if(!number){
      //   number = 1
      //   console.log("number",number);
      // }
      let data = {
        cart_id: id,
        num: number,
      };
      // console.log('number-------',number);
      // return
      that.cartLoading = true;
      this.$http.setCartNum(
        data,
        (res) => {
          if (res.ret == 1) {
            that.getCartList();
            that.$parent.getCartNum(); //调用父组件获取购物车的数量的方法
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 商品数据赋值
     * @param {*} id
     * @param {*} data
     */
    setProductById(id, res) {
      let that = this;
      switch (parseFloat(id)) {
        // 1为你推荐
        case 1:
          that.recommendProductData = res.data;
          that.recommendProductText = {
            name: res.name,
            eng_name: res.eng_name,
          };

          if (
            that.recommendProductData.length > 0 &&
            this.currLanguage != 3 &&
            this.currLanguage != 1
          ) {
            that.translateApiData(res.data, 1, "recommend_product");
          }
          that.translateApiData(res.name, 1, "recommend_product_name");

          break;
        // 2热销产品
        // case 2:
        //   that.hotSaleProductData = data;
        //   break;
        // //3猜你喜欢
        // case 3:
        //   // that.guessLikeProductData = data;
        //   break;

        // default:
        //   that.recommendProductData = data;
        //   break;
      }
    },

    /**
     * 清空购物车
     */
    clearCart() {
      let that = this;
      that.cartLoading = true;
      let data = {
        cookie: that.getCookies(),
      };
      this.$http.deleteAllCart(
        data,
        (res) => {
          if (res.ret == 1) {
            that.pageCount = 0;
            that.getCartList();
            //
            that.productAddCart("", "", "", "", 0);
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
    /**
     *   加入收藏 取消收藏
     * @param {*} id
     * @param {*} status
     * @param {*} index
     */
    productaddCollect(id, status, index, type) {
      // console.log(".add-favorites", id, status, index);
      let that = this;
      // debugger
      console.log("type", type);
      // if (this.$parent.tipsLogin()) return
      // if (status == 0) {
      //   that.collectionFlag = true;
      // } else {
      //   that.collectionFlag = false;
      // }
      that.$parent.productCollect(
        id,
        status,
        (res) => {
          if (res.ret == 1) {
            // if (status == 0) {
            //   that.collectionFlag = 1;
            // } else {
            //   that.collectionFlag = 0;
            // }
            if (type == 1) {
              let newCartList =
                that.shoppCartProductList[index].product_data[0];
              console.log("newCartList", newCartList);
              newCartList.is_collect = !status;
              // that.getCartList();
              // that.$set(that.shoppCartProductList, index, newCartList);
            } else {
              let newData = that.recommendProductData[index];
              console.log("newData", newData);
              newData.is_collect = !status;
              that.$set(that.recommendProductData, index, newData);
            }
            this.$message.success(res.msg);
            // 设置收藏
            // that.getCartList();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },

    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData(data, lev, type) {
      let that = this;
      let newTextArr = [];
      if (type == "recommend_product_name") {
        //商品信息翻译
        newTextArr.push(data);
        that.languageTranslateByArr(newTextArr, 1, type);
      } else if (type == "product") {
        //商品规格属性信息翻译

        let childrenTextArr = [];
        let childrenTextArr_sku = [];
        that.shoppCartProductList.forEach((v, i) => {
          if (v.product_data != undefined && v.product_data.length > 0) {
            v.product_data.forEach((v2, i2) => {
              childrenTextArr.push(i + "@" + i2 + "@" + v2.title);
              childrenTextArr_sku.push(i + "@" + i2 + "@" + v2.specifications);
            });
          }
        });
        that.languageTranslateByArr(childrenTextArr, 2, type);
        that.languageTranslateByArr(childrenTextArr_sku, 2, "product_sku");
      } else {
        //
        data.forEach((v, i) => {
          newTextArr.push(v.title);
        });

        that.languageTranslateByArr(newTextArr, 1, type);
      }
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, lev, type) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, lev, type);
        },
        (res) => {}
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, lev, type) {
      let that = this;
      if (type == "recommend_product_name") {
        that.recommendProductText.name = data[0].translation;
      } else if (type == "product") {
        //购物车商品
        data.forEach((v, i) => {
          let childIndex = 0;
          let lastIndex = 0;
          data.forEach((v, i) => {
            let index = v.query.split("@")[0];
            let childIndex = v.query.split("@")[1];
            that.shoppCartProductList[index].product_data[childIndex].title =
              v.translation.split("@")[2];
          });
        });
      } else if (type == "product_sku") {
        data.forEach((v, i) => {
          let childIndex = 0;
          let lastIndex = 0;
          data.forEach((v, i) => {
            let index = v.query.split("@")[0];
            let childIndex = v.query.split("@")[1];
            that.shoppCartProductList[index].product_data[
              childIndex
            ].specifications = v.translation.split("@")[2];
          });
        });
      } else {
        data.forEach((v, i) => {
          that.recommendProductData[i].title = v.translation;
        });
      }
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr) {
      let that = this;
      let newpagetextArr = [];
      that.translateByArr(arr, (res) => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation);
        });
        that.pageTextArr = newpagetextArr;
      });
    },
    /**
     * 跳转个人中心
     */
    toPersonCenter(index) {
      // if (index == 0) {
      this.$router.push({
        path: "/",
      });
      // }
    },
  },
  mounted() {
    let that = this;
    // 当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    // 购物车列表
    that.getCartList();
    //为你推荐
    that.getProductSignList(1);
    //热销产品
    // that.getProductSignList(2);
    //猜你喜欢
    // that.getProductSignList(3);
    that.languageTranslateByArrs(that.pageTextArr);

    let url = window.location.href
    
    console.log("url",url)
    localStorage.setItem("url",url)
  },
};
</script>


// WEBPACK FOOTER //
// src/view/shoppingcart.vue